const initialYextState = {
  // UI state
  modalOpen: false,
  snackbarOpen: false,
  snackbarMessage: '',
  customToastOpen: false,
  customToastMessage: '',
  
  // Data loading state
  isFetching: false,
  isFetchingLocations: true,
  isScanning: false,
  
  // Error state
  error: null,
  
  // Data
  locations: [],
  currentLocation: null,
  scanResults: null,
  
  // Pagination
  pagination: {
    currentPage: 0,
    perPage: 50,
    total: 0,
    totalPages: 0,
  },
  
  // Filters
  filters: {
    name: '',
    address: '',
    phone: '',
    status: '',
  },
  
  // Sorting
  sorting: {
    orderBy: '',
    order: 'asc', // 'asc' or 'desc'
  },
};

const yextActions = {
  SET_MODAL_OPEN: 'SET_MODAL_OPEN',
  SET_SNACKBAR: 'SET_SNACKBAR',
  SET_CUSTOM_TOAST: 'SET_CUSTOM_TOAST',
  SET_IS_FETCHING: 'SET_IS_FETCHING',
  SET_IS_FETCHING_LOCATIONS: 'SET_IS_FETCHING_LOCATIONS',
  SET_IS_SCANNING: 'SET_IS_SCANNING',
  SET_ERROR: 'SET_ERROR',
  SET_LOCATIONS: 'SET_LOCATIONS',
  SET_CURRENT_LOCATION: 'SET_CURRENT_LOCATION',
  SET_SCAN_RESULTS: 'SET_SCAN_RESULTS',
  CLOSE_SNACKBAR: 'CLOSE_SNACKBAR',
  CLOSE_CUSTOM_TOAST: 'CLOSE_CUSTOM_TOAST',
  SET_PAGINATION: 'SET_PAGINATION',
  SET_CURRENT_PAGE: 'SET_CURRENT_PAGE',
  SET_PER_PAGE: 'SET_PER_PAGE',
  SET_FILTERS: 'SET_FILTERS',
  CLEAR_FILTERS: 'CLEAR_FILTERS',
  SET_SORTING: 'SET_SORTING',
};

function yextReducer(state, action) {
  switch (action.type) {
    case yextActions.SET_MODAL_OPEN:
      return {
        ...state,
        modalOpen: action.payload.modalOpen,
      };
    
    case yextActions.SET_SNACKBAR:
      return {
        ...state,
        snackbarOpen: action.payload.snackbarOpen,
        snackbarMessage: action.payload.snackbarMessage || state.snackbarMessage,
      };
    
    case yextActions.SET_CUSTOM_TOAST:
      return {
        ...state,
        customToastOpen: action.payload.customToastOpen,
        customToastMessage: action.payload.customToastMessage || state.customToastMessage,
      };
    
    case yextActions.SET_IS_FETCHING:
      return {
        ...state,
        isFetching: action.payload.isFetching,
      };
    
    case yextActions.SET_IS_FETCHING_LOCATIONS:
      return {
        ...state,
        isFetchingLocations: action.payload.isFetchingLocations,
      };
    
    case yextActions.SET_IS_SCANNING:
      return {
        ...state,
        isScanning: action.payload.isScanning,
      };
    
    case yextActions.SET_ERROR:
      return {
        ...state,
        error: action.payload.error,
      };
    
    case yextActions.SET_LOCATIONS:
      return {
        ...state,
        locations: action.payload.locations,
      };
    
    case yextActions.SET_CURRENT_LOCATION:
      return {
        ...state,
        currentLocation: action.payload.currentLocation,
      };
    
    case yextActions.SET_SCAN_RESULTS:
      return {
        ...state,
        scanResults: action.payload.scanResults,
      };
    
    case yextActions.CLOSE_SNACKBAR:
      return {
        ...state,
        snackbarOpen: false,
      };
    
    case yextActions.CLOSE_CUSTOM_TOAST:
      return {
        ...state,
        customToastOpen: false,
      };
    
    case yextActions.SET_PAGINATION:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          ...action.payload,
        },
      };
    
    case yextActions.SET_CURRENT_PAGE:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          currentPage: action.payload.currentPage,
        },
      };
    
    case yextActions.SET_PER_PAGE:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          perPage: action.payload.perPage,
          currentPage: 0, // Reset to first page when changing per page
        },
      };
    
    case yextActions.SET_FILTERS:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.payload.filters,
        },
        pagination: {
          ...state.pagination,
          currentPage: 0, // Reset to first page when filters change
        },
      };
    
    case yextActions.CLEAR_FILTERS:
      return {
        ...state,
        filters: {
          name: '',
          address: '',
          phone: '',
          status: '',
        },
        pagination: {
          ...state.pagination,
          currentPage: 0, // Reset to first page when clearing filters
        },
      };
    
    case yextActions.SET_SORTING:
      return {
        ...state,
        sorting: {
          ...state.sorting,
          ...action.payload.sorting,
        },
      };
    
    default:
      return state;
  }
}

export { initialYextState, yextActions, yextReducer };
